import React from 'react';
import Features from './Features';
import Advantages from './Advantages';
import { FAQ } from '../FAQ/faqs';
import Footer from '../Footer';


function TimeRecordingAndBilling() {
  return (
    <>
<Features docname="Time Recording and Billing"/>
<Advantages docname="Time Recording and Billing"/>
<FAQ category="About Accxchange"/>
<Footer segment="Smarty Home"/>
    </>
  );
}

export default TimeRecordingAndBilling;
